import lodash from "lodash";
import deepdash from "deepdash-es";
const _ = deepdash(lodash);
export const GetUISchemaPath = (schemaPath: any) => {
  const pathSchema = lodash.toPath(schemaPath);

  const filteredPathSchema = pathSchema.filter(function (value) {
    return value !== "properties";
  });

  const uiSchemaPath = _.pathToString(filteredPathSchema);

  return uiSchemaPath;
};
